const compras = {
	fetching: 0,
	result: [],
	page: {},
	errors: [],
};

export default compras;
